{
  "install": {
    "aria": "安裝 BidNova 應用程式",
    "title": "安裝 BidNova",
    "body": "將 BidNova 加到主畫面，即時出價、即時通知。",
    "iosBody": "點選「分享」，然後選擇「加至主畫面」即可安裝 BidNova。",
    "iosHint": "分享 → 加至主畫面",
    "action": "安裝應用程式",
    "later": "暫時不用",
    "dismiss": "關閉安裝提示"
  },
  "offline": {
    "title": "目前離線",
    "body": "即時競投需要網絡連線，連線恢復後會自動重新載入。"
  }
}
